import React, { lazy } from 'react'
import increaseOriginalValueRoutes from './IncreaseOriginalValue/IncreaseOriginalValueRoutes'
import provisionImpairmentRoutes from './ProvisionImpairment/ProvisionImpairmentRoutes'
import residualValueRoutes from './ResidualValue/ResidualRoutes'
import usefulLifeRoutes from './UsefulLife/UsefulLifeRoutes'
import decreaseOriginalValueRoutes from './DecreaseOriginalValue/DecreaseOriginalValueRoutes'

const AssetsChangeSubmenu = lazy(() =>
  import('./AssetsChangeSubmenu').then(module => ({
    default: module.AssetsChangeSubmenu,
  }))
)

const assetsChangeSubmenuRoutes = [
  {
    props: { exact: true, path: '/fixed-assets/:CompanyID/assets-change' },
    component: <AssetsChangeSubmenu />,
  },
  ...increaseOriginalValueRoutes,
  ...decreaseOriginalValueRoutes,
  ...provisionImpairmentRoutes,
  ...residualValueRoutes,
  ...usefulLifeRoutes,
]

export default assetsChangeSubmenuRoutes
